import React from 'react';

export const ViewerContext = React.createContext();
